import React from 'react';
import { useTranslation } from 'react-i18next';
import { ADVISOR_GROUPS, SECTION_LABEL_KEYS, ADVISOR_SECTIONS } from '../../utils/advisor';

const LEVELS = [
  { id: 'h', key: 'advisor.hidden', on: { background: '#fee2e2', color: '#991b1b' } },
  { id: 'v', key: 'advisor.view', on: { background: '#e0e7ff', color: '#3730a3' } },
  { id: 'e', key: 'advisor.edit', on: { background: '#dcfce7', color: '#166534' } },
];

// The admin's per-section access for an advisor: Hidden / View / Edit.
// `value` is { section: 'h'|'v'|'e' } for every section.
const AdvisorAccessEditor = ({ value, onChange }) => {
  const { t } = useTranslation();
  const set = (section, level) => onChange({ ...value, [section]: level });
  const setAll = (level) => onChange(Object.fromEntries(ADVISOR_SECTIONS.map((s) => [s, level])));

  const smallBtn = { border: '1.5px solid #e2e8f0', background: '#fff', borderRadius: 8, padding: '0.3rem 0.65rem', fontSize: '0.75rem', fontWeight: 600, color: '#334155', cursor: 'pointer' };

  return (
    <div>
      <div style={{ fontSize: '0.68rem', fontWeight: 700, color: '#94a3b8', letterSpacing: '0.07em', textTransform: 'uppercase', marginBottom: '0.28rem' }}>
        {t('advisor.sectionTitle')}
      </div>
      <div style={{ fontSize: '0.75rem', color: '#64748b', marginBottom: '0.45rem', lineHeight: 1.45 }}>{t('advisor.sectionHint')}</div>
      <div style={{ display: 'flex', gap: '0.4rem', flexWrap: 'wrap', marginBottom: '0.45rem' }}>
        <button type="button" style={smallBtn} onClick={() => setAll('v')}>{t('advisor.allView')}</button>
        <button type="button" style={smallBtn} onClick={() => setAll('h')}>{t('advisor.hideAll')}</button>
      </div>
      <div style={{ border: '1.5px solid #e2e8f0', borderRadius: 10, padding: '0.25rem 0.75rem 0.5rem', background: '#fafafa' }}>
        {ADVISOR_GROUPS.map((group) => (
          <div key={group.labelKey}>
            <div style={{ fontSize: '0.7rem', fontWeight: 600, color: '#64748b', margin: '0.6rem 0 0.15rem' }}>{t(group.labelKey)}</div>
            {group.sections.map((section) => (
              <div key={section} style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: '0.75rem', padding: '0.35rem 0', borderTop: '1px solid #eef2f7' }}>
                <span style={{ fontSize: '0.82rem', color: '#1e293b' }}>{t(SECTION_LABEL_KEYS[section])}</span>
                <span role="radiogroup" aria-label={t(SECTION_LABEL_KEYS[section])}
                  style={{ display: 'inline-flex', flex: 'none', border: '1.5px solid #e2e8f0', borderRadius: 8, overflow: 'hidden', background: '#fff' }}>
                  {LEVELS.map((lvl) => {
                    const on = value[section] === lvl.id;
                    return (
                      <button key={lvl.id} type="button" role="radio" aria-checked={on} onClick={() => set(section, lvl.id)}
                        style={{ border: 'none', padding: '0.28rem 0.6rem', fontSize: '0.72rem', fontWeight: 600, cursor: 'pointer', background: 'transparent', color: '#64748b', ...(on ? lvl.on : {}) }}>
                        {t(lvl.key)}
                      </button>
                    );
                  })}
                </span>
              </div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export default AdvisorAccessEditor;
